import {bootstrapApplication} from "@angular/platform-browser";
import {defineCustomElements as defineUxUiCore} from "@trumpf/ux.ui/loader";
import {defineCustomElements as defineUxAppFramework} from "@trumpf/ux.application-framework/loader";
import {AppComponent} from "./app/app.component";
import {appConfig} from "./app/app.config";

defineUxUiCore();
defineUxAppFramework();

// eslint-disable-next-line no-console
bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
